import {CommonModule} from '@angular/common';
import {Component, computed, input} from '@angular/core';
import {toObservable, toSignal} from '@angular/core/rxjs-interop';
import {FormControl, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatSelectModule} from '@angular/material/select';
import {TranslateModule} from '@ngx-translate/core';
import {SvgIconComponent} from 'angular-svg-icon';
import {map, of, startWith, switchMap} from 'rxjs';
import {InputComponent} from 'src/shared/input/input.component';

export interface DropdownOption
{
    value: string;
    label: string;
    disabled?: boolean;
}

@Component({
    selector: 'app-dropdown',
    standalone: true,
    imports: [
        TranslateModule,
        SvgIconComponent,
        ReactiveFormsModule,
        InputComponent,
        CommonModule,
        MatSelectModule
    ],
    templateUrl: './dropdown.component.html',
    styleUrl: './dropdown.component.scss'
})
export class DropDownComponent
{
    public fieldName = input.required<string>();

    public control = input.required<FormControl>();

    public fullWidth = input<boolean>(true);

    public secureWidth = input<boolean>(true);

    private readonly controlValue$ = toObservable(this.control).pipe(switchMap((control: FormControl) => control ? control.valueChanges.pipe(startWith(control.value)) : of(null)));

    private readonly controlDisabled$ = toObservable(this.control).pipe(switchMap((control: FormControl) => control ? control.statusChanges.pipe(startWith(control.status), map((status: string) => status === 'DISABLED')) : of(null)));

    private readonly controlValue = toSignal(this.controlValue$);

    public readonly disabled = toSignal(this.controlDisabled$);

    public options = input.required<DropdownOption[]>();

    public readonly selectedOptionLabel = computed(() =>
    {
        return this.controlValue() ? this.options().find((option: DropdownOption) => option.value === this.controlValue())?.label : undefined;
    });

    public readonly getRequiredMark = computed(() => this.control().hasValidator(Validators.required) ? '*' : '');
}
